// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// import { getMessaging, getToken } from "firebase/messaging";
// import {sendFCMToken} from '../services/notificationService';


// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyBKE4VGhyL-LDFMOZI4hbmPdHX25IUAbxs",
//   authDomain: "rangooli-95a99.firebaseapp.com",
//   projectId: "rangooli-95a99",
//   storageBucket: "rangooli-95a99.firebasestorage.app",
//   messagingSenderId: "356361663482",
//   appId: "1:356361663482:web:e9fd8e83c9fb66f984aa43",
//   measurementId: "G-JLFMWPK2DD"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
// export const messaging = getMessaging(app);


// // export const generateToken = async () => {
// //   try {
// //     const permission = await Notification.requestPermission();
// //     if (permission !== "granted") return;

// //     const token = await getToken(messaging, {
// //       vapidKey: "BOvQcxdj3pMcKvwWHxsxQWXPP_AKA14P6DNIqUC9ULuFMW582CEVMoFKK81_nMSBq65cvL6hiar3AVMV5hOA8ms",
// //     });
// //     // console.log("FCM Token:", token);
// //     let token_data = {
// //       "token":token,
// //       "user_id":2,
// //       "device_type":'web'
// //     }
// //       const response = await sendFCMToken(token_data)
// //       // console.log(response)
// //     } catch (e) {
// //       console.error("Push registration failed:", e);
// //     }
// //   };

// export const generateToken = async () => {
//   try {
//     // Define isMobile inside the function
//     const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
//       navigator.userAgent
//     );
    
//     // console.log('Device type:', isMobile ? 'Mobile' : 'Desktop');

//     // Check if messaging is supported
//     if (!('Notification' in window)) {
//       // console.log('This browser does not support notifications');
//       return null;
//     }

//     // Ensure service worker is registered
//     if ('serviceWorker' in navigator) {
//       const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
//       // console.log('Service worker registered for token generation');
//     }

//     // Request permission
//     const permission = await Notification.requestPermission();
//     if (permission !== "granted") {
//       // console.log("Notification permission denied");
//       return null;
//     }

//     // Get FCM token with service worker registration
//     const token = await getToken(messaging, {
//       vapidKey: "BOvQcxdj3pMcKvwWHxsxQWXPP_AKA14P6DNIqUC9ULuFMW582CEVMoFKK81_nMSBq65cvL6hiar3AVMV5hOA8ms",
//       serviceWorkerRegistration: await navigator.serviceWorker.ready
//     });

//     if (token) {
//       // console.log("FCM Token generated:", token);
      
//       const token_data = {
//         "token": token,
//         "user_id": 2,
//         "device_type": isMobile ? 'mobile_web' : 'web' // Use isMobile directly (not as function)
//       };
      
//       await sendFCMToken(token_data);
//       return token;
//     }
//   } catch (e) {
//     console.error("Push registration failed:", e);
//     return null;
//   }
// };



// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { sendFCMToken } from '../services/notificationService';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBKE4VGhyL-LDFMOZI4hbmPdHX25IUAbxs",
  authDomain: "rangooli-95a99.firebaseapp.com",
  projectId: "rangooli-95a99",
  storageBucket: "rangooli-95a99.firebasestorage.app",
  messagingSenderId: "356361663482",
  appId: "1:356361663482:web:e9fd8e83c9fb66f984aa43",
  measurementId: "G-JLFMWPK2DD"
};


// const firebaseConfig = {
//   apiKey: "AIzaSyD5T0qTnp2Ae1e5mT8zlYxtTQhyvAT2WGU",
//   authDomain: "rangooli-testing.firebaseapp.com",
//   projectId: "rangooli-testing",
//   storageBucket: "rangooli-testing.firebasestorage.app",
//   messagingSenderId: "163228675298",
//   appId: "1:163228675298:web:e472ca6f30e238fb70c2bb",
//   measurementId: "G-BFD1ZKZCW1"
// };

// Initialize Firebase (this is safe)
const app = initializeApp(firebaseConfig);

// Only initialize analytics on client-side
let analytics = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

// Don't initialize messaging immediately
let messagingInstance = null;

// Export messaging as a promise or function instead of direct instance
export const messaging = {
  getInstance: async () => {
    if (messagingInstance) return messagingInstance;
    
    if (typeof window === 'undefined') return null;
    
    try {
      const { getMessaging, isSupported } = await import('firebase/messaging');
      const supported = await isSupported();
      if (supported) {
        messagingInstance = getMessaging(app);
        return messagingInstance;
      }
    } catch (error) {
      console.warn('Failed to initialize Firebase Messaging:', error);
    }
    
    return null;
  }
};

export const generateToken = async () => {
  try {
    // Get messaging instance lazily
    const messagingInstance = await messaging.getInstance();  // ✅ Different name
    if (!messagingInstance) {
      // console.log('Firebase Messaging not available');
      return null;
    }

    // Define isMobile inside the function
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
    
    // Check if messaging is supported
    if (!('Notification' in window)) {
      return null;
    }

    // Ensure service worker is registered
    if ('serviceWorker' in navigator) {
      await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    }

    // Request permission
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      return null;
    }

    // Dynamically import getToken
    const { getToken } = await import('firebase/messaging');
    
    // Get FCM token with service worker registration - USE THE INSTANCE VARIABLE
    const token = await getToken(messagingInstance, {  // ✅ Changed to messagingInstance
     vapidKey: "BOvQcxdj3pMcKvwWHxsxQWXPP_AKA14P6DNIqUC9ULuFMW582CEVMoFKK81_nMSBq65cvL6hiar3AVMV5hOA8ms",
      serviceWorkerRegistration: await navigator.serviceWorker.ready
    });

    if (token) {
      const token_data = {
        "token": token,
        "user_id": 2,
        "device_type": isMobile ? 'mobile_web' : 'web'
      };
      
      let response = await sendFCMToken(token_data);
      // console.log("FCM Response => ", response)

      localStorage.setItem('tk_id',response?.id)
      
      return token;
    }
  } catch (error) {
    // console.error("Push registration failed:", error);
    return null;
  }
};

export { analytics, app };